import React from "react";

import * as Constants from "../../../consts/Constants.js";
import Typography from "@material-ui/core/Typography";
import Button from '@mui/material/Button';
import ReactJson from 'react-json-view'
import { Grid } from "@material-ui/core";
import CircularProgress from '@mui/material/CircularProgress';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CancelIcon from '@mui/icons-material/Cancel';
import { formatDateDDMMYYYYHHMM } from "../../../plas/utils";

import service from '../../../plas/errors/service';
import alerter from "../../alerts/alerter"

export default function ReportView({
  errorId,
  fullWidth,
  close
}) {

  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  const theme = createTheme({
    palette: {
      primary: {
        main: '#FFFFFF',
        darker: '#FFFFFF',
      }
    },
  });

  React.useEffect(() => {
    loadError()
  }, []);

  const loadError = () => {
    setLoading(true);
    service.api.get(errorId,(response) => {
      if (response.error != null) {
        alerter.showError(response.error);
        close();
      } else {
        setError(response.result);
        setLoading(false);
      }
    })
  }

  const ColoredLine = ({ color }) => (
      <hr
        style={{
            color: color,
            backgroundColor: color,
            marginTop: 6,
            marginBottom: 4,
            height: 2
        }}
      />
  );

  return (
      <Grid container>
        <Grid item xs={12} style={{ textAlign: "center"}}>
          { loading ? (
                <CircularProgress style={{color:Constants.COLOR_PRIMARY}} color="inherit" />
          ) : (
            <Grid container>
              <Grid item xs={false} md={ fullWidth ? false : 2} />
              <Grid item xs={12} md={ fullWidth ? 12 : 8} >
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <p style={{ fontSize: 28, textAlign: 'left'}}>
                      Datos del error
                    </p>
                    <ColoredLine color="gray"/>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <p style={{fontSize: 22, marginBottom: 0, textAlign: 'start'}}>
                          {`${error.service} / ${error.operation}`}
                        </p>
                        { error.userId ? (
                          <Typography style={{fontSize: 16, color: 'gray', textAlign: 'left'}}>
                            { formatDateDDMMYYYYHHMM(error.time) } - { `Usuario ${error.userId}`}
                          </Typography>
                        ):(
                          <Typography style={{fontSize: 16, color: 'gray', textAlign: 'left'}}>
                            { formatDateDDMMYYYYHHMM(error.time) } - Operación automatica
                          </Typography>
                        )}               
                      </Grid>
                      <Grid item xs={12}>
                        <Typography style={{textAlign: 'start'}}>
                          <ReactJson src={error.parameters} enableClipboard={false} displayDataTypes={false} name={"parameters"} />
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography style={{textAlign: 'start'}}>
                          <ReactJson src={error.output} enableClipboard={false} displayDataTypes={false} name={"stack_trace"} />
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <ColoredLine color="gray"/>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      <Grid item xs={true}/>
                      <Grid item>
                        <ThemeProvider theme={theme}>
                          <Button 
                            startIcon={<CancelIcon/>} 
                            variant="contained" 
                            onClick={close}>
                            Cerrar
                          </Button>
                        </ThemeProvider>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={false} md={ fullWidth ? false : 2} />
          </Grid>
          )}
        </Grid>
      </Grid>
  );
}
